<div class="container">
  @if (
    (eventListWrapper$ | async) !== undefined &&
    (eventListWrapper$ | async)?.status === "READY"
  ) {
    <!-- <div class="event-count">
      {{ (eventListWrapper$ | async)?.eventList?.length ?? 0 }} events found
    </div> -->
    <div class="potential-events-table">
      <table
        mat-table
        [dataSource]="(eventListWrapper$ | async)?.eventList || []"
        multiTemplateDataRows
        class="mat-elevation-z8"
        [class.newsite]="showNewDesign"
      >
        <!-- Expansion Arrow Column -->
        <ng-container matColumnDef="expand">
          <th
            class="table-header"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          ></th>
          <td mat-cell *matCellDef="let element">
            <mat-icon
              class="expand-arrow"
              [class.expanded]="isExpanded(element)"
            >
              keyboard_arrow_down
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="eventDate">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
            Event Date
          </th>
          <td class="table-cell" mat-cell *matCellDef="let event">
            {{ event.eventDate | date: "MM/dd/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="eventName">
          <th class="table-header" mat-header-cell *matHeaderCellDef>Name</th>
          <td class="table-cell" mat-cell *matCellDef="let event">
            {{ event.eventName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="organizerName">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
            Organizer
          </th>
          <td class="table-cell" mat-cell *matCellDef="let event">
            {{ event.firstName }} {{ event.lastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="sharedDate">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
            Shared Date
          </th>
          <td class="table-cell" mat-cell *matCellDef="let event">
            {{ formatDate(event.sharedDate) * 1000 | date: "MM/dd/yyyy" }}
          </td>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="event-detail-container"
              [class.expanded]="isExpanded(element)"
            >
              <div class="event-detail-inner">
                <h3 class="event-detail-title">
                  DETAILS FOR POTENTIAL EVENT:
                  {{ element.eventName }}
                </h3>
                <span
                  >Phone: {{ element.phone | phone }} &nbsp;&nbsp;Email:
                  {{ element.email }}</span
                >
                <table
                  mat-table
                  [dataSource]="element.details"
                  style="margin-bottom: 20px"
                >
                  <!-- Inner table column definitions -->
                  <ng-container matColumnDef="customer">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Customer
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.firstName }} {{ detail.lastName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="role">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Role
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.role }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="coat">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Coat
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.coat }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="pant">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Pant
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.pant }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="shirt">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Shirt
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.shirt }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="tie">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Tie
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.tie }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="vest">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Vest
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.vest }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="shoe">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Shoe
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.shoe }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="pocketSquare">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Pocket Square
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.pocketSquare }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="jewelry">
                    <th
                      class="table-header-selected"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Jewelry
                    </th>
                    <td
                      class="details-table-cell"
                      mat-cell
                      *matCellDef="let detail"
                    >
                      {{ detail.jewelry }}
                    </td>
                  </ng-container>

                  <tr
                    class="table-header-row"
                    mat-header-row
                    *matHeaderRowDef="selectedEventDisplayedColumns"
                  ></tr>
                  <tr
                    class="default-row"
                    [ngClass]="{
                      'alt-row': i % 2 === 1,
                    }"
                    mat-row
                    *matRowDef="
                      let row;
                      let i = index;
                      columns: selectedEventDisplayedColumns
                    "
                  ></tr>
                </table>
                @if (!saving() && !saved()) {
                  <div class="action-container" [class.newsite]="showNewDesign">
                    <button
                      mat-flat-button
                      color="primary"
                      [class.pill-accept]="showNewDesign"
                      (click)="onAcceptEvent(element, $event)"
                    >
                      Accept Event
                    </button>
                    <button
                      mat-flat-button
                      color="accent"
                      [class.pill-reject]="showNewDesign"
                      (click)="onRejectEvent(element)"
                    >
                      Reject Event
                    </button>
                  </div>
                } @else {
                  @if (saving()) {
                    <div style="display: flex; justify-content: center">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                  }
                }
              </div>
            </div>
          </td>
        </ng-container>

        <tr
          class="table-header-row"
          mat-header-row
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="event-row"
          [class.expanded-row]="isExpanded(row)"
          (click)="onEventClick(row)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
        ></tr>
      </table>
    </div>
  } @else if (loaded() && !error()) {
    <div>No events found</div>
  } @else if (error()) {
    <mat-error>Error loading events</mat-error>
  }
</div>
